export interface YTPlayerStates {
  UNSTARTED: number
  ENDED: number
  PLAYING: number
  PAUSED: number
  BUFFERING: number
  CUED: number
}

declare global {
  interface Window {
    YT?: {
      Player: new (elementId: string, options: Record<string, any>) => any
      PlayerState: YTPlayerStates
    }
    onYouTubeIframeAPIReady?: () => void
  }
}

// Shared by every player on the page so the API script only loads once
let apiPromise: Promise<void> | null = null

export function loadYouTubeAPI(): Promise<void> {
  if (window.YT?.Player) {
    return Promise.resolve()
  }

  if (!apiPromise) {
    apiPromise = new Promise((resolve) => {
      // Chain any existing handler instead of replacing it
      const previousReady = window.onYouTubeIframeAPIReady
      window.onYouTubeIframeAPIReady = () => {
        previousReady?.()
        resolve()
      }

      if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
        const script = document.createElement('script')
        script.src = 'https://www.youtube.com/iframe_api'
        script.async = true
        document.head.appendChild(script)
      }
    })
  }

  return apiPromise
}
